/**
 * This parsing is highly coupled to what we are looking for with the quill tags.
 * If we do not have this structure, it means we have a bug in our render function
 * since quill will always give us this structure with the blot we have defined.
 *
 * A quill tag will have a structure like this:
 *
 *    <span class="ql-variable">
 *      <span contenteditable="false">user.last_name</span>
 *    </span>
 *
 * And then for such a tag, we will replace it with handle bars e.g.
 *
 *    {{user.last_name}}
 *
 *
 * This is a doozy of a regular expression, so it's broken into parts to help
 * document what each piece is looking for.
 *
 * Note: this allows for some limited variants e.g.
 *  - whitespace before and after className attr and class itself
 *  - inner span can have any attributes
 *  - whitespace before last two closing span tags
 *  - anything can come before or after the whole match
 *  - multiple matches (tags) accounted for
 *  - newlines okay before and after <span> and </span> tags
 *
 * The following comments indicate which part of above example
 */

// <span
const outerSpanOpenStart = /<span\s*/

// class="ql-variable"
const classCheck = /(?:class=(?:"|"([^"]*)\s*)ql-variable(?:"|\s([^"]*)"))/

// >
const outerSpanOpenEnd = /\s*(?:[^>]*?)>/

// <span contenteditable="false">
const innerSpanOpen = /\s*(?:<span(?:[^>]*?)>\s*)/

// user.last_name     ... Group 3
const templateVariable = /(\S*?)/

// </span></span>
const spanClosers = /\s*<\/span>[\s\S]*?<\/span>/

const regex = new RegExp(
  [
    outerSpanOpenStart,
    classCheck,
    outerSpanOpenEnd,
    innerSpanOpen,
    templateVariable,
    spanClosers,
  ]
    .map(r => r.source)
    .join(''),
  'ig'
)

const stripTemplateTags = html => html.replace(regex, '{{$3}}')

export default stripTemplateTags
